import React from 'react';
import Link from '@v2/shared/components/Link';
import { useCart } from '@v2/shared/lib/cart';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import { faShoppingBag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * headless: apps/topmags/layouts/MainLayout/Navigation/CartButton.
 *
 * headless counts `cart.items.length` -- lines, not copies. useCart here exposes
 * cartCount, which is items_quantity and counts copies, so two of one title read as 2
 * rather than 1. That is the number DiscountMags' badge shows, and the one a shopper
 * expects, so it is kept rather than reproducing the line count.
 */
export default function CartButton() {
  const { buildUrl } = useUrlGenerator();
  const { cartCount, loaded } = useCart();

  return (
    <Link href={buildUrl('/cart')} className="flex items-center mr-1 group">
      <span className="inline-flex relative">
        <FontAwesomeIcon icon={faShoppingBag} size="2x" className="text-salmon-500 md:-mt-2" />
        {/* Left out until the cart has loaded, so a bag holding two does not read 0 first. */}
        {loaded && (
          <span className="absolute rounded-md bg-salmon-500 text-white font-semibold text-sm left-0 right-0 bottom-[1px] w-full text-center">
            {cartCount}
          </span>
        )}
      </span>
      <span className="italic text-sm font-serif text-salmon-500 hidden md:inline-flex ml-2 group-hover:text-teal-500 group-hover:underline transition-colors duration-200 ease-linear">
        Shopping Bag
      </span>
    </Link>
  );
}
